import { GET_LOGIN_SUCCESS} from 'constants/index'

export default (state = {}, action) => {
    switch(action.type){
        case GET_LOGIN_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}